import React from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '../../../svg/close.svg';
import { navigate } from 'gatsby'
import useLanguage from '../../../hooks/useLanguage';

import {
  NameInput,
  PhonesInput,
  MailInput,
  TimeInput,
  Terms,
  SubmitButton,
} from '.';

const LEADS_API_URL = process.env.GATSBY_LEADS_API_URL;

const FreeLessonModal = ({ open, closeModal, title }) => {
  const langToggle = useLanguage;
  const [name, setName] = React.useState('');
  const [time, setTime] = React.useState('09:00 - 13:00');
  const [phone, setPhone] = React.useState('');
  const [mail, setMail] = React.useState('');
  const [error, setError] = React.useState('');

  const send = async () => {
    setError('');

    if (!LEADS_API_URL) {
      console.error('GATSBY_LEADS_API_URL is not set');
      setError(
        langToggle(
          'Не вдалося надіслати заявку. Спробуйте ще раз.',
          'Не удалось отправить заявку. Попробуйте еще раз.',
        ),
      );
      return;
    }

    try {
      const response = await fetch(LEADS_API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, phone, mail, time }),
      });

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      navigate('/free-lesson');
    } catch (err) {
      console.error('Failed to submit free lesson request', err);
      setError(
        langToggle(
          'Не вдалося надіслати заявку. Спробуйте ще раз.',
          'Не удалось отправить заявку. Попробуйте еще раз.',
        ),
      );
    }
  };


  return (
    <section className={open ? 'free-modal is-open' : 'free-modal'}>
      <div
        className={open ? 'free-modal__overlay is-open' : 'free-modal__overlay'}
        onClick={closeModal}
        role="presentation"
      ></div>
      <div className="free-modal__wrapper">
        <div
          className={
            open
              ? 'free-modal__form-wrapper is-open'
              : 'free-modal__form-wrapper'
          }
        >
          <button className="free-modal__close" onClick={closeModal}>
            close
            <CloseIcon className="free-modal__close-icon" />
          </button>
          <div className="free-modal__form-overflow">
            <div className="free-modal__form-header">
              <h3 className="free-modal__form-title">{title}</h3>
            </div>
            <form
              className={open ? 'free-modal__form is-open' : 'free-modal__form'}
              onSubmit={(e)=>{e.preventDefault();send()}}
            >
              <NameInput name={name} setName={setName} />
              <MailInput mail={mail} setMail={setMail} />
              <PhonesInput phone={phone} setPhone={setPhone} />
              <TimeInput time={time} setTime={setTime} />
              <Terms />
              {error && <p className="free-modal__form-error">{error}</p>}
              <SubmitButton />
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

FreeLessonModal.propTypes = {
  open: PropTypes.bool,
  closeModal: PropTypes.func,
};

export default FreeLessonModal;
